"use client";

import { Button, Carousel, Input } from "@relume_io/relume-ui";
import React, { useState } from "react";
import {
  BiLogoFacebookCircle,
  BiLogoInstagram,
} from "react-icons/bi";

const useForm = () => {
  const [email, setEmail] = useState("");
  const handleSetEmail = (event) => {
    setEmail(event.target.value);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    console.log({ email });
  };
  return {
    email,
    handleSetEmail,
    handleSubmit,
  };
};

export function Footer() {
  const formState = useForm();
  return (
    <footer id="relume" className="px-[5%] py-12 md:py-18 lg:py-20 bg-gray-50">
      <div className="container">
        <div className="grid grid-cols-1 gap-x-[8vw] gap-y-12 p-8 md:gap-y-16 md:p-12 lg:grid-cols-[0.75fr_1fr] lg:gap-y-4">
          <div className="flex flex-col">
            <a href="#" className="mb-5 md:mb-6">
              <img
                src="/logo.png"
                alt="Logo image"
                className="inline-block w-xs"
              />
            </a>
          </div>
          <div className="grid grid-cols-1 items-start gap-y-10 sm:grid-cols-3 sm:gap-x-6 md:gap-x-8 md:gap-y-4">
            <div className="flex flex-col items-start justify-start">
              <h2 className="mb-3 font-semibold md:mb-4">Mapa del sitio</h2>
              <ul>
                <li className="py-2 text-sm">
                  <a href="/" className="flex items-center gap-3">
                    <span>Inicio</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/nosotros" className="flex items-center gap-3">
                    <span>Nosotros</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Vehículos</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/servicios" className="flex items-center gap-3">
                    <span>Servicios</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/contactos" className="flex items-center gap-3">
                    <span>Contactos</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-start justify-start">
              <h2 className="mb-3 font-semibold md:mb-4">Marcas</h2>
              <ul>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Kia</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Geely</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Ford</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Lincoln</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Mazda</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Shineray</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>SWM</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>JAC</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Farizon</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="/vehiculos" className="flex items-center gap-3">
                    <span>Forland</span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="flex flex-col items-start justify-start">
              <h2 className="mb-3 font-semibold md:mb-4">Síguenos</h2>
              <ul className="flex flex-col items-start">
                <li className="py-2 text-sm">
                  <a href="https://www.facebook.com/profile.php?id=61557141925755" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-blue-600 transition-colors">
                    <BiLogoFacebookCircle className="size-6" />
                    <span>Facebook</span>
                  </a>
                </li>
                <li className="py-2 text-sm">
                  <a href="https://www.instagram.com/vehiculosndc" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-pink-600 transition-colors">
                    <BiLogoInstagram className="size-6" />
                    <span>Instagram</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="flex flex-col-reverse items-start justify-between pt-6 pb-4 text-sm md:flex-row md:items-center md:pt-8 md:pb-0 ">
          <p className="mt-6 md:mt-0">© 2024 Vehículos NDC. All rights reserved.</p>
          <ul className="grid grid-flow-row grid-cols-[max-content] justify-center gap-y-4 text-sm md:grid-flow-col md:gap-x-6 md:gap-y-0">
            <li className="underline">
              <a href="/politica-privacidad">Política de Privacidad</a>
            </li>
            <li className="underline">
              <a href="/terminos-servicio">Términos de Servicio</a>
            </li>
            <li className="underline">
              <a href="/configuracion-cookies">Configuración de Cookies</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}
